import axiosHandler from "../../Intersepter/axiosInstance";

export const registerUser = async (data) => {
    try {
      const response = await axiosHandler.post(`/user/`, data);
      return response.data; 
    } catch (error) {
      console.error("Error registering user:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };